module.exports = __webpack_public_path__ + "img/img-play8-d.b74eba62.png";